var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('div',{ref:"chart",staticClass:"chart"}),_vm._t("options")],2)}
var staticRenderFns = []

export { render, staticRenderFns }